import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 2.25C4.6005 2.25 2.25 4.60051 2.25 7.5V16.4999C2.25 19.3994 4.60051 21.7499 7.5 21.7499H16.5C19.3995 21.7499 21.75 19.3994 21.75 16.4999V7.5C21.75 4.6005 19.3995 2.25 16.5 2.25H7.5ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5ZM12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17ZM17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6C16.4477 6 16 6.44772 16 7C16 7.55228 16.4477 8 17 8Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
